
/**
 * This object serves as wrapper for 
 * window.location.href to ensure our redirection
 * to other url is not interupted by multiple calls to
 * window.location.href = 'some-url'
 * 
 * Calling 
 * window.location.href = 'some-url' will redirect
 * the page to the new url
 * 
 * However, if this is called multiple times, the 
 * previous request is aborted.
 * 
 * Example:
 * 
 * window.location.href = '/home'
 * window.location.href = '/contact'
 * Final result is we will be redirected to '/contact'
 * 
 * Using this wrapper like
 * PageReload.goTo('/home')
 * PageReload.goTo('/contact')
 * 
 * Will bring us to '/home'
 */

 
class PageReload {
    isReloading = false
    init = (app) => {
        this.app = app
    }
    goTableLandingPage = () => {
        // Get TableQR part
        let href = window.location.href
        let newHref = href.substr(href.lastIndexOf('/') + 1)
        let url = '/' + newHref
        if (!this.isReloading) {
            this.isReloading = true
            window.location.href = url
            return true
        }
        return false
    }

    goTo = (url) => {
        if (!this.isReloading) {
            this.isReloading = true
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            const allowedForward = ['js_file']
            let queryKeys = Object.keys(params)
            if (queryKeys.length) {
                let paramsToForward = {}
                let paramsCount = 0
                allowedForward.forEach(param => {
                    let index = queryKeys.indexOf(param)
                    if (index !== -1) {
                        paramsCount++
                        paramsToForward[param] = params[param]
                    }
                })
                if (paramsCount) {
                    const paramsString = (new URLSearchParams(paramsToForward)).toString()
                    url += `?${paramsString}`
                }
            }
            window.location.href = url
            return true
        }
        return false
    }

    executeReload = () => {
        if (window.flutter_inappwebview && window.isFlutterAppReady) {
            window.flutter_inappwebview.callHandler('reloadPage')
            return
        }
        window.location.reload()
    }

    reload = () => {
        if (!this.isReloading) {
            this.isReloading = true
            if (this.app && this.app.setState) {
                this.app.setState({
                    forceShowLoading: true,
                }, () => {
                    setTimeout(() => {
                        this.executeReload()
                    }, 200)
                })
            }
            else {
                this.executeReload()
            }
            
            // After 20 seconds, if page not reloaded, remove progress bar and reset flag
            // that user can try again
            if (this.reloadTimer) {
                clearTimeout(this.reloadTimer)
            }
            this.reloadTimer = setTimeout(() => {
                this.isReloading = false
                if (this.app && this.app.setState) {
                    this.app.setState({
                        forceShowLoading: false,
                    })
                }
            }, 20 * 1000);
            return true
        }
        return false
    }
}

export let pageReload = new PageReload();